<template lang="html">
  <div class="vx"  v-show="groupVisible">
    <div class="vx_conent">
      <div class="vx_header">
        <div class="vx_qun">
          <div class="vx_header_img">
            <img :src="headPortrait" alt="">
          </div>
          <div class="vx_header_name">
            <div>{{ actName }}</div>
            <p>随时随地交流学习</p>
          </div>
          <img src="../assets/image/VXlogo.png" alt="" class="vxLogo">
        </div>
      </div>
      <div class="vx_footer">
        <div class="vx_ma">
          <img :src="yard" alt="">
        </div>
        <div class="vx_txt">
          长按图片识别二维码
        </div>
      </div>
    </div>
    <div class="" @click="groupsCancel()">
      <img src="../assets/image/VX_off.png" alt="" class="on_off">
    </div>
  </div>
</template>

<script>
export default {
  props: ["groupVisible", "headPortrait", "actName", "yard"],
  data(){
    return{
      moduleVX: [],
    }
  },
  mounted(){
    
  },
  methods:{
    groupsCancel () {
      this.$emit('groupCancel')
    },
  }
}
</script>

<style lang="css" scoped>
.vx{
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.vx_conent{
  width: 290px;
  height: 413px;
  background-color: #ffffff;
}
.vx_header{
  box-sizing: border-box;
  width: 100%;
  height: 130px;
  background-color: #E50120;
  padding-left: 18px;
  padding-top: 22px;

}
.vx_qun{
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
}
.vx_header_img{
  width: 47px;
  height: 47px;
  background-color: #ffffff;
  object-fit: cover;
}
.vx_header_img img{
  width: 100%;
  height: 100%;
}
.vx_header_name{
  margin-left: 9px;
  padding-left: 9px;
  border-left: 2px solid #ffffff;
}
.vx_header_name div{
  font-size: 14px;
  color: #ffffff;
}
.vx_header_name p{
  font-size: 11px;
  margin-top: 5px;
  color: #ffffff;
}
.vxLogo{
  width: 95px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: 35px;
  margin-left: -55px;
}
.vx_footer{
  height: 285px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.vx_ma{
  margin-top: 20px;
  width: 140px;
  height: 140px;
  background-color: #D8D8D8;
}
.vx_ma img{
  width: 100%;
  height: 100%;
}
.vx_txt{
  width: 165px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  color: #E50120;
  margin-top: 30px;
  border: 1px solid #E50120;
  border-radius: 11px;
}

.on_off{
  margin-top: 25px;
  width: 50px;
}
</style>
